@if (order$ | async; as order) {
  <div class="cx-page-header">
    <h1 class="cx-page-title">
      {{ 'checkoutOrderConfirmation.confirmationOfOrder' | cxTranslate }}
      {{ order.replenishmentOrderCode ?? order.code }}
    </h1>
  </div>
  <div class="cx-order-confirmation-message">
    <h2>{{ 'checkoutOrderConfirmation.thankYou' | cxTranslate }}</h2>
  </div>
  @if (isGuestCustomer) {
    <div>
      <cx-guest-register-form [guid]="orderGuid" [email]="order.paymentInfo.billingAddress.email">
      </cx-guest-register-form>
    </div>
  }
  <cx-add-to-home-screen-banner></cx-add-to-home-screen-banner>
}
